import React from 'react';

import { LoginForm } from './components/LoginForm';

type LoginProps = {
    isRegister?: boolean;
}

export const Login: React.FC<LoginProps> = ({ isRegister }: LoginProps) => <LoginForm isRegister={isRegister}/>
